module.exports = __webpack_public_path__ + "static/media/ic_feedback.d6dc9be8.svg";